import React from 'react';
import { ChevronDownIcon, ChevronUpIcon, MinusIcon, TimerIcon } from 'lucide-react';
import { optionsBand } from '../data/content';
import { SectionHeading } from './SectionHeading';

/** EASIER / STANDARD / HARDER rows (full class names so Tailwind keeps them) */
const levelStyles = [{
  tag: 'bg-leaf text-white',
  Icon: ChevronDownIcon
}, {
  tag: 'bg-white text-brand',
  Icon: MinusIcon
}, {
  tag: 'bg-coral text-white',
  Icon: ChevronUpIcon
}];

/** New in this landing: every station has 3 options + the timer formats used all year */
export function OptionsBand() {
  return <section aria-labelledby="options-title" className="bg-ink py-12 md:py-16" data-id="element-215" data-mp="wn9dku5feusq">
      <div className="mx-auto max-w-page px-5 md:px-8" data-id="element-216" data-mp="wpc219qxkfvc">
        <SectionHeading id="options-title" tone="dark" eyebrow={optionsBand.eyebrow} title={optionsBand.title} sub={optionsBand.sub} data-id="element-217" data-mp="11krdjv1gtzol" />

        <ul className="mx-auto mt-8 grid max-w-[980px] gap-3 md:mt-10 md:grid-cols-3 md:gap-4" data-id="element-218" data-mp="16jcdrugpwjd1">
          {optionsBand.examples.map(ex => <li key={ex.station} className="overflow-hidden rounded-xl bg-brand ring-1 ring-white/10" data-id="element-219" data-mp="1wo5til2ydntx">
              <p className="bg-sun px-4 py-2.5 font-display text-[20px] font-black uppercase leading-none tracking-wide text-ink" data-id="element-220" data-mp="1rmzy2fhwrmgp">{ex.station}</p>
              <ul className="space-y-2 p-4" data-id="element-221" data-mp="1mqroriqe6nhg">
                {ex.options.map((opt, i) => {
              const s = levelStyles[i];
              return <li key={opt} className="flex items-center gap-3" data-id="element-222" data-mp="2fd42gp2x7q8r" data-mpi={i}>
                      <span className={`inline-flex w-[104px] shrink-0 items-center gap-1 rounded-md px-2 py-1 font-display text-[13px] font-black tracking-[0.08em] ${s.tag}`} data-id="element-223" data-mp="2ae98cqzi6f9c">
                        <s.Icon className="h-3.5 w-3.5" strokeWidth={3} aria-hidden="true" data-id="element-224" data-mp="21mh2ktlfbub3" />
                        {optionsBand.levels[i]}
                      </span>
                      <span className="text-[15px] leading-snug text-white/90" data-id="element-225" data-mp="2y67ygh3m2f6j">{opt}</span>
                    </li>;
            })}
              </ul>
            </li>)}
        </ul>

        <h3 className="mt-10 flex items-center justify-center gap-2 text-center font-display text-[16px] font-black tracking-[0.12em] text-sun" data-id="element-226" data-mp="ri7ca1d2cib3">
          <TimerIcon className="h-4 w-4" strokeWidth={2.5} aria-hidden="true" data-id="element-227" data-mp="hp08um1vvcdn" />
          {optionsBand.timersTitle}
        </h3>
        <ul className="mx-auto mt-4 grid max-w-[980px] grid-cols-2 gap-2.5 md:grid-cols-4 md:gap-3" data-id="element-228" data-mp="mnbiavo9nkvc">
          {optionsBand.timers.map(t => <li key={t.name} className="rounded-xl border border-white/10 bg-brand px-4 py-3" data-id="element-229" data-mp="do6hfip8ffg0">
              <p className="font-display text-[26px] font-black leading-none tracking-tight text-white" data-id="element-230" data-mp="3uwtkmg1casky">{t.name}</p>
              <p className="mt-1 text-[13px] leading-snug text-white/75" data-id="element-231" data-mp="3ph1hvgwc52e">{t.text}</p>
            </li>)}
        </ul>
      </div>
    </section>;
}